export { EmptyState } from '@microservices/design-system';
export type { EmptyStateProps } from '@microservices/design-system';
